import {
  serviceInfo,
  vipJoin,
  getServiceCountPrice,
  servicePay
} from '@/services/config'
export default {
  namespaced: true,
  state: {
    serviceInfo: {} // 成本维护全局弹框
  },
  mutations: {
    setServiceInfo (state, data) {
      state.serviceInfo = data
    }
  },
  actions: {
    async getServiceInfo ({ commit }) {
      // commit('setSubmitting', true)
      const chain = await serviceInfo()
        .onSuccess(raw => {
          commit('setServiceInfo', raw)
        })
        .onNetComplete(() => {
          // commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async vipJoin ({ commit }) {
      // commit('setSubmitting', true)
      const chain = await vipJoin()
        .onSuccess(raw => {
        })
        .onNetComplete(() => {
          // commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    // 计算服务价格
    async getCountPrice ({ commit }, data) {
      commit('setSubmitting', true)
      const chain = await getServiceCountPrice()
        .params(data)
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async pay ({ commit }) {
      commit('setSubmitting', true)
      const chain = await servicePay()
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: true })
      return chain
    }
  }
}
